export default __webpack_public_path__ + "static/media/card-img-01.931954d4.png";